import { render, staticRenderFns } from "./tab_main.vue?vue&type=template&id=6ccae3a4&"
import script from "./tab_main.vue?vue&type=script&lang=js&"
export * from "./tab_main.vue?vue&type=script&lang=js&"
import style0 from "./tab_main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports